var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftScrollArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5195 6.40039L7.89951 10.9904L12.5195 15.5804",
    stroke: "#666666",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9599 20.98C5.45914 20.98 0.999908 16.5073 0.999908 10.99C0.999908 5.4727 5.45914 1 10.9599 1C16.4607 1 20.9199 5.4727 20.9199 10.99C20.9199 16.5073 16.4607 20.98 10.9599 20.98Z",
    stroke: "#666666",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftScrollArrow);
export default __webpack_public_path__ + "static/media/left-scroll-arrow.a125f1cb5612a6a3366c28744b0e93dd.svg";
export { ForwardRef as ReactComponent };